import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Filter} from '../common/domain/filter';
import {ProductDto} from '../@api';

@Injectable()
export class ProductService {

    constructor(private http: HttpClient) { }

    getProductsSmall() {
        return this.http.get<any>('assets/demo/data/products-small.json')
            .toPromise()
            .then(res => res.data as ProductDto[])
            .then(data => data);
    }

    getProducts() {
        return this.http.get<any>('assets/demo/data/products.json')
            .toPromise()
            .then(res => res.data as ProductDto[])
            .then(data => data);
    }

    getProductsMixed() {
        return this.http.get<any>('assets/demo/data/products-mixed.json')
            .toPromise()
            .then(res => res.data as ProductDto[])
            .then(data => data);
    }

    getProductsWithOrdersSmall() {
        return this.http.get<any>('assets/demo/data/products-orders-small.json')
            .toPromise()
            .then(res => res.data as ProductDto[])
            .then(data => data);
    }

    /*getProduct(code: string) {
        return this.http.get<any>('assets/demo/data/' + code + '.json')
            .toPromise()
            .then(res => res as Product)
            .then(data => data);
    }*/

    getFilterConfig() {
        return this.http.get<any>('assets/demo/data/filter-config.json')
            .toPromise()
            .then(res => res.data as Filter[])
            .then(data => data);
    }
}
